import { z } from "zod";

const TargetRefByIdSchema = z.object({
  id: z.string().uuid({ message: "Id is required." }),
  name: z.string().optional().nullable(),
});
const ControlRefByIdSchema = z.object({
  id: z.string().uuid({ message: "Id is required." }),
  shortCode: z.string().optional().nullable(),
});

const CreateAuditPeriodSchema = z
  .object(
    {
      from: z
        .string({
          required_error: "Audit period start date is required.",
        })
        .datetime({ offset: true }),
      to: z
        .string({
          required_error: "Audit period end date is required.",
        })
        .datetime({ offset: true }),
    },
    { required_error: "Audit period is required.", invalid_type_error: "Audit period is required." }
  )
  .refine((data) => new Date(data.to) > new Date(data.from), { message: "End date must be after start date." });

const CreateAuditSchema = z
  .object({
    title: z
      .string()
      .min(1, { message: "Title is required." })
      .max(400, { message: "Title must not be longer than 400 characters." }),
    description: z.string().min(1, { message: "Description is required." }),
    period: CreateAuditPeriodSchema,
    registryId: z.string().uuid({ message: "Registry identifier is required." }),
    deploymentTargets: z.array(TargetRefByIdSchema).min(1, "Required."),
    controls: z.array(ControlRefByIdSchema).min(1, "Required."),
  })
  .strict();

export default CreateAuditSchema;
